import { render, staticRenderFns } from "./MiQr.vue?vue&type=template&id=b4476922&scoped=true"
import script from "./MiQr.vue?vue&type=script&lang=js"
export * from "./MiQr.vue?vue&type=script&lang=js"
import style0 from "./MiQr.vue?vue&type=style&index=0&id=b4476922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4476922",
  null
  
)

export default component.exports